import { throttle } from 'lodash-es';

export default class Header {
    constructor() {
        this.header = document.querySelector('.page-header');
        this.scrollThreshold = 100; // Default threshold in pixels
        this.init();
    }

    init() {
        // Initialize scroll event listener
        this.setupScrollListener();
    }

    setupScrollListener() {
        // Check initial scroll position
        this.checkScroll();
        
        // Create throttled scroll handler using lodash-es
        // This will limit execution to once every 100ms
        const throttledScrollHandler = throttle(() => {
            this.checkScroll();
        }, 100);
        
        // Add scroll event listener with throttle
        window.addEventListener('scroll', throttledScrollHandler);
    }

    checkScroll() {
        const scrollPosition = window.scrollY || window.pageYOffset;
        
        if (scrollPosition > this.scrollThreshold) {
            document.body.classList.add('scroll');
        } else {
            document.body.classList.remove('scroll');
        }
    }
}